import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getBonusDeducts = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_BONUSDEDUCT_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};
